import React from 'react';
import { useNavigate } from 'react-router-dom';
import { restoreAdminSession } from '../utils/auth';

const ImpersonationBanner = () => {
    const navigate = useNavigate();

    const handleReturn = () => {
        const restored = restoreAdminSession();
        if (restored.success) {
            navigate(restored.returnPath || '/AdminDashboard/manage-users', { replace: true });
        } else {
            navigate('/AdminDashboard/manage-users', { replace: true });
        }
    };

    return (
        <div style={{
            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
            color: 'white',
            padding: '0.625rem 1.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '1rem',
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            fontSize: '0.875rem',
            fontWeight: 600,
            flexShrink: 0,
        }}>
            <span>Admin Impersonation Mode — You are viewing as another user</span>
            <button
                onClick={handleReturn}
                style={{
                    background: 'white',
                    color: '#b45309',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '0.375rem 1rem',
                    fontSize: '0.8rem',
                    fontWeight: 700,
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                }}
            >
                ← Return to Admin
            </button>
        </div>
    );
};

export default ImpersonationBanner;
